import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Select from "react-select";
import makeAnimated from "react-select/animated";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
// import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SellingService from "../services/SellingService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import Societe from "../services/Societe";
const DataTableProductsSale = ({ listProduits, refrech, setRefrech }) => {
  console.log("listProduits", listProduits);
  const animatedComponents = makeAnimated();

  const [products, setProducts] = useState(listProduits);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [confidentialCode, setConfidentialCode] = useState("");
  const [newValue, setNewValue] = useState("");
  const [newQuantity, setNewQuantity] = useState("");
  const [codeBarreProduct, setCodeBarreProduct] = useState("");

  const [newPrice, setNewPrice] = useState(0);
  const [newPricehtc, setNewPricehtc] = useState(0);
  const [newPercentPricehtc, setNewPercentPricehtc] = useState(0);

  const [isCodeValid, setIsCodeValid] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [show, setShow] = useState(false); // Modal visibility
  const [showAddProduct, setShowAddProduct] = useState(false); // Modal visibility
  const [showChangeClient, setShowChangeClient] = useState(false); // Modal visibility
  const [clients, setClients] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [clientSelectedOption, setClientSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [clientId, setClientId] = useState(0);
  const [clientSelectPlaceHolder, setClientSelectPlaceHolder] =
    useState("Choisir...");

  const CONFIDENTIAL_CODE = "SECRET123"; // Static confidentiality code
  useEffect(() => {

    Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((reponse) => {
        setClients(reponse.data["Societe"]);
      })
      .catch((e) => {
        console.log("error", e)
      });
  }, []);

  useEffect(() => {
    clients &&
      clients.map((element, i) => {
        let exist = false;
        if (allClients.length !== 0) {
          for (let index = 0; index < allClients.length; index++) {
            if (allClients[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllClients((oldArray) => [
            ...oldArray,
            {
              value: element.id, label: element.title, customElements: {
                seuil: element.seuil,
              }
            },
          ]);
        }
      });
  }, [clients]);

  const handleShow = () => setShow(true);
  const handleShowAddProduct = () => setShowAddProduct(true);
  const handleShowChangeClient = () => setShowChangeClient(true);

  const handleClose = () => {
    setShow(false);
    setConfidentialCode("");
    setNewValue("");
    setIsCodeValid(false);
  };

  const handleCloseProduct = () => {
    setShowAddProduct(false);
    setConfidentialCode("");
    setNewValue("");
    setIsCodeValid(false);
  };

  const handleCloseChangeClient = () => {
    setShowChangeClient(false);
    setConfidentialCode("");
    setNewValue("");
    setIsCodeValid(false);
  };
  const handleConfidentialCodeChange = (e) => {
    setConfidentialCode(e.target.value);

    // Check if the entered code matches the static code
    if (e.target.value === CONFIDENTIAL_CODE) {
      setIsCodeValid(true);
    } else {
      setIsCodeValid(false);
    }
  };

  const handleNewValueChange = (e) => {
    setNewValue(e.target.value);
  };

  const handleDeleteProduct = async () => {
    try {
      // Validate inputs
      const refDocument = sessionStorage.getItem('refDocument');
      const productId = selectedRow?.product?.id;

      if (!refDocument || !productId) {
        console.error('Missing required data: refDocument, product ID, or quantity.');
        return;
      }

      // Update product quantity
      await SellingService.removeProdutToFactureByFacture(
        getCurrentUserId(),
        refDocument,
        productId
      );

      // Optional: Notify the user
      // console.log('Quantity updated successfully.');

      // Refresh the data or UI instead of reloading the page
      // fetchUpdatedData(); // Replace with your data fetching logic
      setRefrech(!refrech);
      handleClose();
      window.location.reload()

    } catch (error) {
      // Handle errors gracefully
      console.error('Error updating quantity:', error);
    }
  };
  const handleUpdateQuantity = async () => {
    try {
      // Validate inputs
      const refDocument = sessionStorage.getItem('refDocument');
      const productId = selectedRow?.product?.id;
      const trimmedQuantity = newQuantity.trim();

      if (!refDocument || !productId || !trimmedQuantity) {
        console.error('Missing required data: refDocument, product ID, or quantity.');
        return;
      }

      // Update product quantity
      await SellingService.updateFactureProductQteByFacture(
        getCurrentUserId(),
        refDocument,
        productId,
        trimmedQuantity
      );

      // Optional: Notify the user
      // console.log('Quantity updated successfully.');

      // Refresh the data or UI instead of reloading the page
      // fetchUpdatedData(); // Replace with your data fetching logic
      setRefrech(!refrech);
      handleClose();
    } catch (error) {
      // Handle errors gracefully
      console.error('Error updating quantity:', error);
    }
  };
  const handleUpdatePrice = async () => {
    try {
      // Validate inputs
      const refDocument = sessionStorage.getItem('refDocument');
      const productId = selectedRow?.product?.id;
    
      if (!refDocument || !productId ) {
        console.error('Missing required data: refDocument, product ID, or quantity.');
        return;
      }

      // Update product quantity
      await SellingService.updateFactureProductPriceByFacture(
        getCurrentUserId(),
        refDocument,
        productId,
        newPricehtc,
        newPercentPricehtc,
        newPrice
      );
      setRefrech(!refrech);
      handleClose();
    } catch (error) {
      // Handle errors gracefully
      console.error('Error updating price product:', error);
    }
  };

  const handleAddNewProductPrice = async () => {
    try {
      // Validate inputs
      const refDocument = sessionStorage.getItem('refDocument');


      const trimmedQuantity = newQuantity.trim();

      if (!refDocument || !codeBarreProduct ||  !trimmedQuantity) {
        console.error('Missing required data: refDocument, product ID, or quantity.');
        return;
      }

      // Update product quantity
      await SellingService.addProdutToFactureByFactureByBarCode(
        getCurrentUserId(),
        refDocument,
        codeBarreProduct,
        trimmedQuantity,
         newPricehtc,
        newPercentPricehtc,
        newPrice
      );
      setRefrech(!refrech);
      handleCloseProduct();
      window.location.reload()

    } catch (error) {
      // Handle errors gracefully
      console.error('Error updating quantity:', error);
    }
  };



  const handleChangeClient = async () => {
    try {
      // Validate inputs
      const refDocument = sessionStorage.getItem('refDocument');
    

      if (!refDocument ) {
        console.error('Missing required data: refDocument, product ID, or quantity.');
        return;
      }

      // Update product quantity
      await SellingService.updateFactureClient(
        getCurrentUserId(),
        refDocument,clientId
       
      );
      handleCloseChangeClient();
      window.location.reload()

    } catch (error) {
      // Handle errors gracefully
      console.error('Error updating quantity:', error);
    }
  };




  const handleSubmit = () => {
    if (isCodeValid && newValue.trim()) {
      // handleUpdate(selectedRow.id, newValue); // Pass ID and new value to the update handler
      handleClose(); // Close the modal
    } else {
      alert("Please enter a valid confidentiality code and a new value.");
    }
  };

  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  function lotFormatter(cell, row) {
    if (cell === undefined || cell === null) {
      return <span>-----------</span>;
    } else {
      return <span>{cell.serialNumber}</span>;
    }
  }
  function buttonEditFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        className="btn bg-black btn-sm"
        onClick={() => {
          // Your click handling logic here
          setSelectedRow(row)
          console.log(row);
          handleShow()
        }}
      >
        <i className="fas fa-edit"></i> {/* Changed icon to 'fa-edit' */}
      </button>
    );
  }

  const columns = [
    {
      dataField: "product.name",
      text: "Libellé",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "product.productCode",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "manufacturingBatch",
      text: "Lot",
      formatter: lotFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "promotionPercentage",
      text: "Remise",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix.V.U",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "priceTt",
      text: "Prix.U.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "priceTt",
      text: "Action",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
      formatter: buttonEditFormatter,
    },
  ];

  const rates = (row) => {
    if (row.ratePPs.length !== 0) {
      console.log("rates", row.ratePPs);
      return (
        <div class="col-md-12">
          <div class="card card-dark collapsed-card">
            <div class="card-header">
              <h3 class="card-title">
                Prix d'achat + coût de revient: {row.finalPriceHtc} /{" "}
                {row.finalPriceTt}
              </h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="card-body">{listRates(row.ratePPs)}</div>
          </div>
        </div>
      );
    }
  };
  const listRates = (list) => {
    return (
      <table
        class="table table-striped table-bordered table-sm"
        cellspacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "40%" }}>Libellé</th>
            <th style={{ width: "30%" }}>Valeur</th>
            <th style={{ width: "30%" }}>Ref Facture</th>
          </tr>
        </thead>
        <tbody>
          {list &&
            list.map((element, i) => (
              <tr className="text-center" key={i}>
                <td>{element.name}</td>
                <td>{element.value} </td>
                <td>{formatRefBill(element)}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  const formatRefBill = (rate) => {
    // console.log("row", row);
    if (
      rate.refBill !== null &&
      rate.refBill !== "none" &&
      rate.refBill !== ""
    ) {
      return <span>{rate.refBill}</span>;
    } else {
      return <span>-----------</span>;
    }
  };
  const importProduct = (row) => {
    if (row.isImport === 1) {
      return (
        <div className="row">
          {" "}
          <p> Local</p>
          {rates(row)}
        </div>
      );
    } else {
      return (
        <div className="row">
          <div class="col-md-12">
            <p>Importé</p>
          </div>
          <div class="col-md-12">
            <p>{`Prix Unitaire sans remise: ${row.currencyPrice}`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Prix Unitaire avec remise: ${row.currencyPrice -
              (row.currencyPrice * row.promotionPercentage) / 100
              }`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Devise: ${row.currency}`}</p>
          </div>
          <div class="col-md-12">
            <p>{`Taux de change: ${row.exchangeRate}`}</p>
          </div>
          {rates(row)}
        </div>
      );
    }
  };
  const expandRow = {
    renderer: (row) => importProduct(row),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  // function handleTableChange({ products }) {
  //   return products;
  // }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const onChangeSelectedClient = (selectedOptionn) => {
    setSelectedOption();
    setClientId(selectedOptionn.value);
    setClientSelectPlaceHolder(selectedOptionn.label);



  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">
          Produits </h3>
        <div className="row">  <div className="col-md-2 float-right">
          <button
            style={{ width: 40 }}
            className="btn bg-black btn-sm"
            onClick={() => {
              handleShowAddProduct()
            }}
          >
            <i className="fas fa-add"></i> {/* Changed icon to 'fa-edit' */}
          </button></div>


          <div className="col-md-4">
            <button
              className="btn bg-black btn-sm"
              onClick={() => {
                handleShowChangeClient()
              }}
            >
              <i className="fas fa-edit"></i> Changer client {/* Changed icon to 'fa-edit' */}
            </button></div></div>

      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={products}
          columns={columns}
          //   onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Modifier le produit</Modal.Title>
          <button className="close" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Code à barre : </strong>
            {selectedRow && selectedRow.product.barcode}
          </p>
          <p>
            <strong>Nom : </strong>
            {selectedRow && selectedRow.product.name}
          </p>
          <hr />
          <p>
            Veuillez entrer le code de confidentialité pour continuer :
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="Entrez le code de confidentialité"
            value={confidentialCode}
            onChange={handleConfidentialCodeChange}
          />
          {isCodeValid && (
            <>
              <br />
              <p>Code valide. Modifiez les valeurs ci-dessous :</p>
              <div>
                <label>quantité :</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez la nouvelle quantité"
                  value={newQuantity}
                  onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              <br />
              <div>
                <label>prix htc:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPricehtc}
                  onChange={(e) => setNewPricehtc(e.target.value)}
                />
              </div>
              <div>
                <label>Promotion en %:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPercentPricehtc}
                  onChange={(e) => setNewPercentPricehtc(e.target.value)}
                />
              </div>
              <div>
                <label>prix ttc:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPrice}
                  onChange={(e) => setNewPrice(e.target.value)}
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={handleDeleteProduct}
            disabled={!isCodeValid}
          >
            Supprimer le produit
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdateQuantity}
            disabled={!isCodeValid }
          >
            Changer la quantité
          </Button>
          <Button
            variant="success"
            onClick={handleUpdatePrice}
            disabled={!isCodeValid }
          >
            Changer le prix
          </Button>
        </Modal.Footer>
      </Modal>

     


      <Modal show={showAddProduct} onHide={handleCloseProduct} centered>
        <Modal.Header>
          <Modal.Title>Ajouter un produit</Modal.Title>
          <button className="close" onClick={handleCloseProduct}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Modal.Header>
        <Modal.Body>

          <p>
            Veuillez entrer le code de confidentialité pour continuer :
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="Entrez le code de confidentialité"
            value={confidentialCode}
            onChange={handleConfidentialCodeChange}
          />
          {isCodeValid && (
            <>

              <br />
              <p>Code valide. Modifiez les valeurs ci-dessous :</p>
              <div>
                <label>Code à barre :</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Entrez la nouvelle quantité"
                  value={codeBarreProduct}
                  onChange={(e) => setCodeBarreProduct(e.target.value)}
                />
              </div>
              <br />
              <div>
                <label>quantité :</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez la nouvelle quantité"
                  value={newQuantity}
                  onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>
              <br />
              <div>
                <label>prix htc:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPricehtc}
                  onChange={(e) => setNewPricehtc(e.target.value)}
                />
              </div>
              <div>
                <label>Promotion en %:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPercentPricehtc}
                  onChange={(e) => setNewPercentPricehtc(e.target.value)}
                />
              </div>
              <div>
                <label>prix ttc:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Entrez le nouveau prix"
                  value={newPrice}
                  onChange={(e) => setNewPrice(e.target.value)}
                />
              </div>

            </>
          )}
        </Modal.Body>
        <Modal.Footer>

          <Button
            variant="success"
            onClick={handleAddNewProductPrice}
            disabled={!isCodeValid }
          >
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showChangeClient} onHide={handleCloseChangeClient} centered>
        <Modal.Header>
          <Modal.Title>Changer le client</Modal.Title>
          <button className="close" onClick={handleCloseChangeClient}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Modal.Header>
        <Modal.Body>

          <p>
            Veuillez entrer le code de confidentialité pour continuer :
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="Entrez le code de confidentialité"
            value={confidentialCode}
            onChange={handleConfidentialCodeChange}
          />
          {isCodeValid && (
            <>

              <br />
              <p>Code valide. Modifiez les valeurs ci-dessous :</p>
              <div>
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Choisir le client <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={clientSelectedOption}
                    onChange={onChangeSelectedClient}
                    options={allClients}
                    placeholder={clientSelectPlaceHolder}
                  />
                </div>
              </div>

            </>
          )}
        </Modal.Body>
        <Modal.Footer>

          <Button
            variant="success"
            onClick={handleChangeClient}
            disabled={!isCodeValid}
          >
            Ajouter
          </Button>
        </Modal.Footer>
      </Modal>
      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
export default DataTableProductsSale;
